import { Lightning } from "react-bootstrap-icons";
import { BaseWidget } from "../common";
import "../../styles/EnhancementWidget.css";

export function EnhancementWidget({ onOpen }) {
  return (
    <BaseWidget
      title="Enhancement Request"
      accentColor="var(--cp-gold-500)"
      headerRight={
        <div className="cp-enhance-widget__badge">
          <Lightning />
        </div>
      }
    >
      <p className="cp-enhance-widget__copy">
        Have an idea that would make your workflow easier? Submit a feature
        request or UI improvement and help shape the future of ClearPoint.
      </p>

      <button type="button" className="cp-enhance-widget__cta" onClick={onOpen}>
        <Lightning />
        Submit a request
      </button>
    </BaseWidget>
  );
}
